import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "col-lg-8" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, "Send Envelope Document")
], -1)
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "button-header text-lg-right upload-btn-wrap" }
const _hoisted_8 = /*#__PURE__*/_createVNode("button", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_9 = {
  class: "card p-0",
  id: "uploadedPdfTemplate"
}
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table mb-0 table-shadowed" }
const _hoisted_12 = /*#__PURE__*/_createVNode("thead", { class: "table-primary text-nowrap" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Template"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Current Status"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-external-link-alt mx-2" }, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { colspan: "5" }
const _hoisted_17 = { class: "modal-wrap" }
const _hoisted_18 = {
  class: "modal fade",
  id: "responseModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_20 = { class: "modal-content  mh-auto" }
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-success text-center mb-0",
    role: "alert"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-check-circle mr-2" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("strong", null, "Successfully uploaded the PDF."),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("small", null, "During Beta, as a thank you, the Convorally team will make all of your document templates interactive. We will generate your document link within 24 to 48 hours and notify you via email.")
    ])
  ])
], -1)
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = { class: "modal-wrap" }
const _hoisted_27 = {
  class: "modal fade",
  id: "deleteConfirmeModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_29 = { class: "modal-content  mh-auto" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Delete Confirm "),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-success text-center mb-0",
    role: "alert"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-check-circle mr-2" }),
    /*#__PURE__*/_createTextVNode(" Are you sure you want to delete ? ")
  ])
], -1)
const _hoisted_32 = { class: "modal-footer" }
const _hoisted_33 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " No ", -1)
const _hoisted_34 = { class: "modal-wrap lg-size" }
const _hoisted_35 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMember",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_36 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_37 = { class: "modal-content" }
const _hoisted_38 = { class: "modal-header" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Create Envelope "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Create project to collaborate with other members. ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_41 = { class: "modal-body" }
const _hoisted_42 = { class: "form-wrap pt-0" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Title", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite new member by", -1)
const _hoisted_46 = { class: "input-btn" }
const _hoisted_47 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_48 = { class: "mb-0" }
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_50 = { class: "modal-footer" }
const _hoisted_51 = {
  class: "alert alert-success text-center",
  role: "alert"
}
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"card\"><div class=\"row align-items-center\"><div class=\"col-lg-8\"><h1 class=\"title mb-2\">Receive Envelope Document</h1></div><div class=\"col-lg-4\"></div></div></div>", 1)
const _hoisted_53 = {
  class: "card p-0",
  id: "uploadedPdfTemplate"
}
const _hoisted_54 = { class: "table-responsive" }
const _hoisted_55 = { class: "table mb-0 table-shadowed" }
const _hoisted_56 = /*#__PURE__*/_createVNode("thead", { class: "table-primary text-nowrap" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Template"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Current Status"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createVNode("i", { class: "fa fa-external-link-alt mx-2" }, null, -1)
const _hoisted_59 = { class: "table-button" }
const _hoisted_60 = /*#__PURE__*/_createVNode("i", { class: "fa fa-stop-circle" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Sign Documehnt")
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { colspan: "5" }
const _hoisted_64 = { class: "modal-wrap" }
const _hoisted_65 = {
  class: "modal fade",
  id: "responseModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_66 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_67 = { class: "modal-content  mh-auto" }
const _hoisted_68 = { class: "modal-header" }
const _hoisted_69 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-success text-center mb-0",
    role: "alert"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-check-circle mr-2" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("strong", null, "Successfully uploaded the PDF."),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("small", null, "During Beta, as a thank you, the Convorally team will make all of your document templates interactive. We will generate your document link within 24 to 48 hours and notify you via email.")
    ])
  ])
], -1)
const _hoisted_72 = { class: "modal-footer" }
const _hoisted_73 = { class: "modal-wrap" }
const _hoisted_74 = {
  class: "modal fade",
  id: "deleteConfirmeModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_75 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_76 = { class: "modal-content  mh-auto" }
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Delete Confirm "),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-success text-center mb-0",
    role: "alert"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-check-circle mr-2" }),
    /*#__PURE__*/_createTextVNode(" Are you sure you want to delete ? ")
  ])
], -1)
const _hoisted_79 = { class: "modal-footer" }
const _hoisted_80 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " No ", -1)
const _hoisted_81 = { class: "modal-wrap lg-size" }
const _hoisted_82 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMember",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_83 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_84 = { class: "modal-content" }
const _hoisted_85 = { class: "modal-header" }
const _hoisted_86 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Create Envelope "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Create project to collaborate with other members. ")
], -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_88 = { class: "modal-body" }
const _hoisted_89 = { class: "form-wrap pt-0" }
const _hoisted_90 = { class: "form-group" }
const _hoisted_91 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Title", -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite new member by", -1)
const _hoisted_93 = { class: "input-btn" }
const _hoisted_94 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_95 = { class: "mb-0" }
const _hoisted_96 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_97 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (
      _ctx.state.ui.isLoading.clientDocumentList ||_ctx.state.ui.isPostLoading.uploadClientDocument)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn d-inline-block",
                id: "uploadPdfForDigitize",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showInviteModel && _ctx.showInviteModel(...args)))
              }, [
                _hoisted_8
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("table", _hoisted_11, [
            _hoisted_12,
            (
              _ctx.state.data.clientDocuments && _ctx.state.data.clientDocuments.length
            )
              ? (_openBlock(), _createBlock("tbody", _hoisted_13, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.clientDocuments, (document, documentIndex) => {
                    return (_openBlock(), _createBlock("tr", { key: documentIndex }, [
                      _createVNode("td", null, [
                        _createVNode("p", null, [
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.docusignTempleteDetails(document.uuid))
                          }, [
                            _createTextVNode(_toDisplayString(document.name) + " ", 1),
                            _hoisted_14
                          ], 8, ["onClick"])
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("p", null, _toDisplayString(document.status), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("tfoot", _hoisted_15, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_16, [
                      _createVNode(_component_EmptyData, {
                        title: _ctx.state.data.title,
                        heading: _ctx.state.data.heading
                      }, null, 8, ["title", "heading"])
                    ])
                  ])
                ]))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("h5", _hoisted_22, _toDisplayString(_ctx.state.data.selectDocument), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideResponseModal && _ctx.hideResponseModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_23
                ])
              ]),
              _hoisted_24,
              _createVNode("div", _hoisted_25, [
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideResponseModal && _ctx.hideResponseModal(...args)))
                }, " Close ")
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _hoisted_30,
              _hoisted_31,
              _createVNode("div", _hoisted_32, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteDocument && _ctx.deleteDocument(...args)))
                }, " Yes "),
                _hoisted_33
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_34, [
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideInviteModel && _ctx.hideInviteModel(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_40
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.invite.title = $event)),
                        type: "email",
                        class: "form-control",
                        id: "exampleInputEmail1",
                        "aria-describedby": "emailHelp",
                        placeholder: "Title"
                      }, null, 512), [
                        [_vModelText, _ctx.state.invite.title]
                      ]),
                      _hoisted_45,
                      _createVNode("div", _hoisted_46, [
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.inviteMember = $event)),
                          type: "email",
                          class: "form-control",
                          id: "exampleInputEmail1",
                          "aria-describedby": "emailHelp",
                          placeholder: "Invite member",
                          onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.state.inviteMember]
                        ]),
                        _createVNode("button", {
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                        }, [
                          _hoisted_47
                        ])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          key: inviteIndex,
                          class: "email-tag"
                        }, [
                          _createVNode("p", _hoisted_48, [
                            _createTextVNode(_toDisplayString(invite) + " ", 1),
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                            }, [
                              _hoisted_49
                            ], 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_50, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.createEvelopeDocument && _ctx.createEvelopeDocument(...args)))
                }, "Create")
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 1,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_51, _toDisplayString(_ctx.state.data.successFulMessage), 1)
            ]),
            _: 1
          }, 8, ["onClose", "showModal"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", null, [
      _hoisted_52,
      _createVNode("div", _hoisted_53, [
        _createVNode("div", _hoisted_54, [
          _createVNode("table", _hoisted_55, [
            _hoisted_56,
            (
              _ctx.state.data.clientReceiveDocuments && _ctx.state.data.clientReceiveDocuments.length
            )
              ? (_openBlock(), _createBlock("tbody", _hoisted_57, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.clientReceiveDocuments, (document, documentIndex) => {
                    return (_openBlock(), _createBlock("tr", { key: documentIndex }, [
                      _createVNode("td", null, [
                        _createVNode("p", null, [
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.docusignTempleteDetails(document.uuid))
                          }, [
                            _createTextVNode(_toDisplayString(document.name) + " ", 1),
                            _hoisted_58
                          ], 8, ["onClick"])
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("p", null, _toDisplayString(document.status), 1)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_59, [
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            class: "btn disable-btn mr-1",
                            onClick: ($event: any) => (_ctx.signDocument(document.uuid))
                          }, [
                            _hoisted_60,
                            _hoisted_61
                          ], 8, ["onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("tfoot", _hoisted_62, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_63, [
                      _createVNode(_component_EmptyData, {
                        title: _ctx.state.data.title,
                        heading: _ctx.state.data.heading
                      }, null, 8, ["title", "heading"])
                    ])
                  ])
                ]))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_64, [
        _createVNode("div", _hoisted_65, [
          _createVNode("div", _hoisted_66, [
            _createVNode("div", _hoisted_67, [
              _createVNode("div", _hoisted_68, [
                _createVNode("h5", _hoisted_69, _toDisplayString(_ctx.state.data.selectDocument), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideResponseModal && _ctx.hideResponseModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_70
                ])
              ]),
              _hoisted_71,
              _createVNode("div", _hoisted_72, [
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.hideResponseModal && _ctx.hideResponseModal(...args)))
                }, " Close ")
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_73, [
        _createVNode("div", _hoisted_74, [
          _createVNode("div", _hoisted_75, [
            _createVNode("div", _hoisted_76, [
              _hoisted_77,
              _hoisted_78,
              _createVNode("div", _hoisted_79, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.deleteDocument && _ctx.deleteDocument(...args)))
                }, " Yes "),
                _hoisted_80
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_81, [
        _createVNode("div", _hoisted_82, [
          _createVNode("div", _hoisted_83, [
            _createVNode("div", _hoisted_84, [
              _createVNode("div", _hoisted_85, [
                _hoisted_86,
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideInviteModel && _ctx.hideInviteModel(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_87
                ])
              ]),
              _createVNode("div", _hoisted_88, [
                _createVNode("div", _hoisted_89, [
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.invite.title = $event)),
                        type: "email",
                        class: "form-control",
                        id: "exampleInputEmail1",
                        "aria-describedby": "emailHelp",
                        placeholder: "Title"
                      }, null, 512), [
                        [_vModelText, _ctx.state.invite.title]
                      ]),
                      _hoisted_92,
                      _createVNode("div", _hoisted_93, [
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.inviteMember = $event)),
                          type: "email",
                          class: "form-control",
                          id: "exampleInputEmail1",
                          "aria-describedby": "emailHelp",
                          placeholder: "Invite member",
                          onKeyup: _cache[17] || (_cache[17] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.state.inviteMember]
                        ]),
                        _createVNode("button", {
                          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                        }, [
                          _hoisted_94
                        ])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          key: inviteIndex,
                          class: "email-tag"
                        }, [
                          _createVNode("p", _hoisted_95, [
                            _createTextVNode(_toDisplayString(invite) + " ", 1),
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                            }, [
                              _hoisted_96
                            ], 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_97, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.createEvelopeDocument && _ctx.createEvelopeDocument(...args)))
                }, "Create")
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 0,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal,
            titleMessage: _ctx.state.data.successFulMessage
          }, null, 8, ["onClose", "showModal", "titleMessage"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}